import { ButtonProps } from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import { Dialog } from "../../../components/Dialog";
import { useToast } from "../../../hooks/useToast";
import { updateNote } from "../../../services/person";
import { queryClient } from "../../../services/queryClient";
import { Note, Person } from "../../../types/person";

type EditNoteProps = {
  note: Note;
  person: Person;
  open: boolean;
  onClose: () => void;
};

export function EditNote({
  note: oldNote,
  person,
  open,
  onClose,
}: EditNoteProps) {
  const [note, setNote] = useState<string>();

  useEffect(() => {
    if (oldNote) {
      setNote(oldNote.nota);
    }
  }, [oldNote]);

  const toast = useToast();

  const handleClose = useCallback(() => {
    onClose();
    setNote("");
  }, [onClose]);

  const putNote = useMutation(
    async () => {
      const objectRequestData = {
        id_pessoa: person.id_pessoa,
        nota: note,
        id: oldNote.id,
      };
      const response = await updateNote(objectRequestData);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Nota atualizada com sucesso!", { severity: "success" });
        queryClient.invalidateQueries(["notes"]);
        handleClose();
      },
      onError: () => {
        toast.show("Erro ao atualizar a nota!", { severity: "error" });
      },
    }
  );

  const handleSave = useCallback(async () => {
    await putNote.mutateAsync();
  }, [putNote]);

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        disabled: putNote.isLoading,
        children: "Voltar",
        onClick: handleClose,
      },
      {
        disabled: putNote.isLoading,
        children: putNote.isLoading ? "Enviado solicitação..." : "Salvar",
        variant: "contained",
        onClick: handleSave,
      },
    ];
  }, [putNote, handleSave, handleClose]);

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      title="Nova nota"
      open={open}
      actions={actions}
      onClose={handleClose}
    >
      <TextField
        margin="normal"
        autoFocus
        rows={5}
        multiline
        label="Texto"
        onChange={({ target: { value } }) => setNote(value)}
        fullWidth
        size="small"
        value={note}
      />
    </Dialog>
  );
}
